export const LABELS = {
  noValueSelected: 'No value selected',
  errorMessage: 'Something went wrong while setting the field value. Please try again.',
}
